import makeAjaxRequest from "helpers/makeAjaxRequest";
import { findIndex, move, pipe, propEq } from "ramda";
import { esysDataServiceUrl } from "../constants";
import { GET_COUNTRY_LIST, GET_STATE_LIST, IS_EDITING } from "../types";

function addLabelValue(params) {
  const a = {};
  a.label = params.name;
  a.value = params.id;
  a.code = params.code;
  return a;
}
function moveCountryToTop(list, country) {
  const idx = findIndex(propEq("label", country))(list);
  return pipe(move(idx, 0))(list);
}
export const fetchCountryList = () => async (dispatch) => {
  try {
    const data = await makeAjaxRequest.fetchWithAuth(`${esysDataServiceUrl}/esys/countries`);
    const intermediate = data.map((d) => addLabelValue(d));
    const countries = moveCountryToTop(moveCountryToTop(intermediate, "Canada"), "USA");

    dispatch({
      type: GET_COUNTRY_LIST,
      payload: countries
    });

    const stateData = await makeAjaxRequest.postWithAuth(`${esysDataServiceUrl}/esys/states`, {});
    const states = stateData.data.map((d) => ({
      label: d.stateName,
      value: d.stateCode,
      cnyId: d.cnyId
    }));

    dispatch({
      type: GET_STATE_LIST,
      payload: states
    });
  } catch (error) {
    console.error(error);
  }
};
export const fetchStateProvince = () => async dispatch => {
  dispatch({
    type: GET_STATE_LIST,
    payload: makeAjaxRequest.postWithAuth(`${esysDataServiceUrl}/esys/states`, {}).then(({ data }) =>
      data.map(d => ({ label: d.stateName, value: d.stateCode, cnyId: d.cnyId }))
    )
  });
};

export const flagEditing = payload => async dispatch => {
  dispatch({
    type: IS_EDITING,
    payload: Promise.resolve(payload)
  });
};
